// DiaWolt's own contact details, shown on the public pages (landing,
// Terms, Privacy). One place, so the pages never disagree.

export const CONTACT_EMAIL = 'info@diawolt.com';

// WhatsApp (chat or call). `wa` = digits only, for https://wa.me/<number>.
export const WHATSAPP_NUMBERS = [
  { display: '+32 489 30 87 15', wa: '32489308715',  tel: '+32489308715',  country: 'Belgium' },
  { display: '+91 98203 91547',  wa: '919820391547', tel: '+919820391547', country: 'India' },
];
